export enum SubscriptionStatusEnum {
    INCOMPLETE = 'incomplete', // First payment not successful yet
    INCOMPLETE_EXPIRED = 'incomplete_expired', // Subscription expired before first payment
    TRIALING = 'trialing', // Currently in trial period
    ACTIVE = 'active', // Subscription active and paid
    PAST_DUE = 'past_due', // Payment failed, Stripe will retry
    CANCELED = 'canceled', // Subscription canceled
    UNPAID = 'unpaid', // Payment failed, subscription inactive
}
